/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Action } from '@ngrx/store';
import { loaderReducer } from '../loader/loader.reducer';
import { ScopedLoaderState } from './scoped-loader.state';
import {EntityScopedLoaderActions} from "./entity-scoped-loader.actions";
import EntityScopedLoaderAction = EntityScopedLoaderActions.EntityScopedLoaderAction;

export const initialScopedLoaderState: ScopedLoaderState<any> = {};

/**
 * Higher order reducer designed to add scope support for loader reducer
 *
 * @param entityType
 * @param reducer
 */
export function scopedLoaderReducer<T>(
  entityType: string,
  reducer?: (state: T | undefined, action: Action) => T
): (
  state: ScopedLoaderState<T>,
  action: EntityScopedLoaderAction
) => ScopedLoaderState<T> {
  const loader = loaderReducer<T>(entityType, reducer);

  return (
    state: ScopedLoaderState<T> = initialScopedLoaderState,
    action: EntityScopedLoaderAction
  ): ScopedLoaderState<T> => {
    if (action && action.meta && action.meta.entityType === entityType) {
      return {
        ...state,
        [action.meta.scope ?? '']: loader(
          state[action.meta.scope ?? ''],
          action
        ),
      };
    }
    return state;
  };
}
